import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent';
import UserAvatar from '..';

import './UserAvatarWithName.scss';

export default class UserAvatarWithName extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { test: true };
  }

  handleClick() {
    if (this.props.selectUser) {
      this.props.selectUser(this.props.user);
    }
  }

  render() {
    let { user } = this.props;
    let userName = ((user.first_name + ' ') || '') + (user.last_name || '');
    return (
      <div className="mobile-user-avatar-with-name" onClick={this.handleClick}>
        <div className="mobile-avatar">
          <UserAvatar id={'mobile-user-avatar-with-name' + user.id} key={'mobile-user-avatar-with-name' + user.id} user={user} larger={'larger'} />
        </div>
        <div className="mobile-user-list-container">
            <div className="mobile-user-list-box">
              <div className="mobile-user-name">{userName}</div>
              <div className="mobile-button-container">         
              </div>
            </div>
            
        </div>
        <hr className="user-line"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserAvatar/MobileUserAvatarWithName/index.js